import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import Header from "../components/Header";
import Footer from '../components/Footer'

const Law = () => (
    <div>
        <Header/>
        <div className="content partslist-page">
            <div className="container">
                <div class="pb-5">
                    <h1 className="title-partslist-page">特定商取引に関する法律に基づく表記</h1>
                    <div className="img-three-dot">
                        <img src="images/three-dot.png" className="img-fluid"/>
                    </div>
                    <div className="table-parts-page pt-3">
                        <table className="table table-parts">
                            <tbody>
                            <tr>
                                <td className="td-custom-parts">販売業者</td>
                                <td>株式会社dsc</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">運営責任者</td>
                                <td>加藤　琢也</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">住所</td>
                                <td>〒150-0002<br/>
                                    東京都渋谷区渋谷2-22-6 幸和ビル2階</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">電話番号</td>
                                <td>03-3797-9067</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">FAX番号</td>
                                <td>03-3797-9067</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">メールアドレス</td>
                                <td><a href="mailto:info@sashiire.jp">info@sashiire.jp</a></td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">URL</td>
                                <td><a href="http://dsc-web.com/" target="_blank">http://dsc-web.com/</a></td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">商品以外の必要代金</td>
                                <td>振込手数料<br/>
                                    ※代金のお支払い時に発生する、振込手数料はお客様負担とさせていただきます。</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">注文方法</td>
                                <td>インターネットでのご注文のみ承っております。</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">支払方法</td>
                                <td>クレジットカード決済、銀行振込</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">支払期限</td>
                                <td>当店より「ご注文受付完了メール」をお送りしますので、メールでお知らせする口座へ1週間以内にお振込ください。</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">引渡し時期</td>
                                <td>ご入金完了後、5営業日程度でサシイレ先部活にお届けします。</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">返品・交換について</td>
                                <td>ご購入後のお客様都合による返品、キャンセルはお受けしておりません。</td>
                            </tr>
                            </tbody>
                        </table>
                        <table className="table table-parts-mb">
                            <tbody>
                            <tr>
                                <td className="td-custom-parts">販売業者</td>
                            </tr>
                            <tr>
                                <td>株式会社dsc</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">運営責任者</td>
                            </tr>
                            <tr>
                                <td>加藤　琢也</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">住所</td>
                            </tr>
                            <tr>
                                <td>〒150-0002<br/>
                                    東京都渋谷区渋谷2-22-6 幸和ビル2階</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">電話番号</td>
                            </tr>
                            <tr>
                                <td>03-3797-9067</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">FAX番号</td>
                            </tr>
                            <tr>
                                <td>03-3797-9067</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">メールアドレス</td>
                            </tr>
                            <tr>
                                <td><a href="mailto:info@sashiire.jp">info@sashiire.jp</a></td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">URL</td>
                            </tr>
                            <tr>
                                <td><a href="http://dsc-web.com/" target="_blank">http://dsc-web.com/</a></td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">商品以外の必要代金</td>
                            </tr>
                            <tr>
                                <td>振込手数料<br/>
                                    ※代金のお支払い時に発生する、振込手数料はお客様負担とさせていただきます。</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">注文方法</td>
                            </tr>
                            <tr>
                                <td>インターネットでのご注文のみ承っております。</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">支払方法</td>
                            </tr>
                            <tr>
                                <td>クレジットカード決済、銀行振込</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">支払期限</td>
                            </tr>
                            <tr>
                                <td>当店より「ご注文受付完了メール」をお送りしますので、メールでお知らせする口座へ1週間以内にお振込ください。</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">引渡し時期</td>
                            </tr>
                            <tr>
                                <td>ご入金完了後、5営業日程度でサシイレ先部活にお届けします。</td>
                            </tr>
                            <tr>
                                <td className="td-custom-parts">返品・交換について</td>
                            </tr>
                            <tr>
                                <td>ご購入後のお客様都合による返品、キャンセルはお受けしておりません。</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
)

export default Law